import React from "react";
import "./Second.css";

function Second() {
  return (
    <>
      <div className="blank">
        <h1>All-New Interior</h1>
      </div>
      <div className="main2"></div>
    </>
  );
}

export default Second;
